<div class="qrCodeContainer" *ngIf="currentNews" [@fadeIn]="animationStateIn" [@fadeOut]="animationStateOut"
    [@fadeInOut]="animationQRCodeStateOut? 'out':'in'" [@zoomIn]="animationStateIn" [@zoomOut]="animationStateOut"
    (@fadeOut.done)="animOutDone()" (@fadeIn.done)="animInDone()">
    <div class="text">
        <p [innerHTML]="'NEWS.QR_CODE' | translate"></p>
    </div>
    <div class="qrCodeParent">
        <div class="qrCodeBox">
            <div class="borderAnimationTop" id="borderAnimationTop"></div>
            <div class="borderAnimationRight" id="borderAnimationRight"></div>
            <div class="borderAnimationBottom" id="borderAnimationBottom"></div>
            <div class="borderAnimationLeft" id="borderAnimationLeft"></div>
            <div class="qrCodePanel">
                <qrcode class="qrCode" [qrdata]="getUrl(currentNews.url)" [width]="qrCodeSize" [errorCorrectionLevel]="'M'"
                    [margin]="0" [colorDark]="'#ffffff'" [colorLight]="'#ffffff00'">
                </qrcode>
            </div>
        </div>
    </div>
</div>